export default "__VITE_ASSET__BoPiGzvN__"